// Handle a growl type notification, and prevent Collaterate from showing it
window.tbg.notifications.on(window.tbg.notifications.GROWL_NOTIFICATION, { preventCollaterateAction: true }, function (event, data) {
    var dataTypeClass = data.type.charAt(0).toUpperCase() + data.type.slice(1).toLowerCase();
    var messageContainer = document.getElementById('collaterateInfo');
    var growlMessageHtml = '<div class="collaterateInfo-message is'+dataTypeClass+' "><p class="collaterateInfo-message-bd">' + data.message + '</p><span class="collaterateInfo-message-close js-close-message" aria-label="Dismiss" role="button"></span>'

    // Adding to the DOM
    messageContainer.insertAdjacentHTML("afterBegin", growlMessageHtml);
    var message = messageContainer.firstElementChild;
    // Animating out after 5 seconds
    setTimeout(deactivateMessage, 5000);
    // Animating out on click
    message.querySelector('.js-close-message').addEventListener('click', deactivateMessage);
    // Removing from the DOM
    setTimeout( function() { message.remove(); }, 6000);

    function deactivateMessage () {
        message.classList.add('isInactive');
    }
});